import React, { useState } from "react";
import AppButton from "../../UI/AppButtons";
import AlertMessage from "../../../views/AlertMessage";
import { t } from "i18next";
import BookingGetters from "../../../store/onlineBooking/getters";
const getDealerNameStyle = (
  isSmallScreen,
  isIphoneScreen,
  isAndroidScreen
) => ({
  width: isSmallScreen ? "50%" : "",
  marginTop: isSmallScreen ? "3%" : "",
  marginLeft: isIphoneScreen || isAndroidScreen ? "5%" : "",
  fontSize: "24px",
  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
});

const getLocationStyle = (isSmallScreen, isIphoneScreen, isAndroidScreen) => ({
  fontSize: !isSmallScreen ? "24px" : "14px",
  width: isSmallScreen ? "50%" : "",
  marginLeft: isIphoneScreen || isAndroidScreen ? "5%" : "",
});

const DealerInfo = ({
  bookingDetails,
  isSmallScreen,
  isIphoneScreen,
  isAndroidScreen,
}) => {
  const containerStyle = {
    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
    marginTop: isSmallScreen ? "50px" : "100px",
  };

  const dealerNameStyle = getDealerNameStyle(
    isSmallScreen,
    isIphoneScreen,
    isAndroidScreen
  );
  const locationStyle = getLocationStyle(
    isSmallScreen,
    isIphoneScreen,
    isAndroidScreen
  );

  return (
    <span
      className="my-[0px] md:my-[40px] md:flex-row md:float-left md:ml-[150px]"
      style={containerStyle}
    >
      <div style={dealerNameStyle}>
        {bookingDetails?.pickUpLocationDetails?.dealerName}
      </div>
      <div style={locationStyle}>
        {bookingDetails?.pickUpLocationDetails?.locationDescription}
      </div>
    </span>
  );
};
const PriceDisplay = ({
  totalPrice,
  activeStep,
  isDesktopScreen,
  istabletScreen,
  isSmallScreen,
}) => {
  if (activeStep !== 3) return null;
  if (isDesktopScreen || istabletScreen) {
    return (
      <span
        className="md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
        style={{
          fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
          fontSize: "48px",
          marginRight: "30px",
          marginTop: "28px",
          marginBottom: "15px",
        }}
      >
        {totalPrice.toFixed(2)}€<span>{" / "}</span>
        <span style={{ fontSize: "18px" }}>{t("Total")}</span>
      </span>
    );
  }
  if (isSmallScreen) {
    return (
      <span className={`flex flex-col mt-[-25%] ml-[32%]`}>
        <span
          className="text-white ml-[60%]"
          style={{
            fontFamily: "MBCorpoSText-Regular-Web-new",
            fontSize: "11px",
          }}
        >
          {t("Total Amount")}
        </span>
        <span
          className="md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal ml-[60%]"
          style={{
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            fontSize: "32px",
            marginRight: "30px",
            color: "#0078D6",
            marginTop: "8px",
          }}
        >
          {totalPrice.toFixed(2)}€
        </span>
        <br />
      </span>
    );
  }
  return null;
};

const BackButton = ({ isSmallScreen, onClick }) => (
  <AppButton
    fontFamily="MBCorpoSText-Light-Web-Text-Light"
    className={`mx-auto ${
      isSmallScreen ? "mb-2" : ""
    } flex justify-center items-center`}
    color="secondaryColor"
    style={{
      width: isSmallScreen ? "90vw" : "230.68px",
      maxWidth: "375px",
      border: "1px solid #FFFFFF",
    }}
    onClick={onClick}
  >
    {t("< Back")}
  </AppButton>
);

const ActionButton = ({ isSmallScreen, onClick, isBookNow }) => {
  const buttonStyle = {
    width: isSmallScreen ? "90vw" : "230.68px",
    maxWidth: "375px",
    fontFamily: "MBCorpoSText-Light-Web-Text-Light",
  };
  return (
    <AppButton
      fontFamily="MBCorpoSText-Light-Web-Text-Light"
      className={`${isSmallScreen ? "mb-2" : ""} ${
        isBookNow ? "mx-4" : isSmallScreen ? "" : "ml-[10px]"
      } flex justify-center items-center mr-[25px]`}
      style={buttonStyle}
      color="primary"
      onClick={onClick}
    >
      {isBookNow ? (
        <span style={{ fontSize: "16px" }}>{t("Book Now")}</span>
      ) : (
        t("Next >")
      )}
    </AppButton>
  );
};

const NavigationButtons = ({
  activeStep,
  isSmallScreen,
  prevActiveStep,
  handleNextClick,
}) => {
  const handleBackClick = () => {
    window.scrollTo(0, 0);
    prevActiveStep();
  };

  return (
    <>
      {activeStep !== 3 && (
        <BackButton isSmallScreen={isSmallScreen} onClick={handleBackClick} />
      )}
      <ActionButton
        isSmallScreen={isSmallScreen}
        onClick={handleNextClick}
        isBookNow={activeStep === 3}
      />
    </>
  );
};

function useModal() {
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const onRequestClose = () => setOpenModal(false);
  return {
    openModal,
    setOpenModal,
    modalMessage,
    setModalMessage,
    onRequestClose,
  };
}

function useScreenSize() {
  const isIphoneScreen = window.innerWidth >= 400 && window.innerWidth <= 768;
  const isAndroidScreen = window.innerWidth <= 400;
  return { isIphoneScreen, isAndroidScreen };
}

function useNextClickHandler(
  canProceed,
  activeStep,
  updateActiveStep,
  setModalMessage,
  setOpenModal
) {
  const handleNextClick = () => {
    if (!canProceed.value) {
      let message = "";
      switch (activeStep) {
        case 3:
          message = t(
            "Please agree to the terms and privacy policy to proceed."
          );
          break;
        case 7:
          message = t("Please fill additional driver details.");
          break;
        case 8:
          message = t("Insert your anagraphic data");
          break;
        default:
          message = t("Please complete all required fields.");
      }
      setModalMessage(message);
      setOpenModal(true);
      return;
    }
    if (activeStep === 3) {
      window.scrollTo(0, document.body.scrollHeight);
    } else {
      window.scrollTo(0, 0);
    }
    updateActiveStep();
  };
  return { handleNextClick };
}
const getFooterStyle = (
  isSmallScreen: boolean,
  activeStep: number
): React.CSSProperties => ({
  position: isSmallScreen && activeStep === 1 ? "relative" : "relative",
  height: activeStep !== 3 && activeStep !== 4 ? "180px" : "159px",
  zIndex: 10,
  maxWidth: "1462px",
  width: "100%",
  margin: "0 auto",
});
const getSpanClass = (isDesktopScreen, istabletScreen) =>
  `flex flex-col md:flex-row ${
    isDesktopScreen
      ? "md:mr-[125px] md:ml-[150px] md:float-right"
      : istabletScreen
      ? "mr-[25px] mt-[60px]"
      : "mt-[10px]"
  }`;

const getMarginTop = (activeStep, isDesktopScreen) =>
  activeStep === 3 ? "46px" : isDesktopScreen ? "60px" : "";

function BookingFooter({
  updateActiveStep,
  prevActiveStep,
  canProceed,
  activeStep,
  totalPrice,
  istabletScreen,
  isDesktopScreen,
  isSmallScreen,
}) {
  const {
    openModal,
    setOpenModal,
    modalMessage,
    setModalMessage,
    onRequestClose,
  } = useModal();
  const { isIphoneScreen, isAndroidScreen } = useScreenSize();
  const { handleNextClick } = useNextClickHandler(
    canProceed,
    activeStep,
    updateActiveStep,
    setModalMessage,
    setOpenModal
  );
  const bookingDetails = BookingGetters.getBookingDetails();

  return (
    <div style={{ width: "100%", background: "#000000" }}>
      <AlertMessage
        openModal={openModal}
        isTermsConditionPopUp={true}
        requestOnClose={onRequestClose}
        modalMessage={modalMessage}
      />
      <div
        // className="bg-[#000000] flex flex-col md:flex-row justify-between items-center box-border"
        className={`${
          isSmallScreen
            ? "bg-[#000000]"
            : "flex flex-col md:flex-row justify-between items-center box-border"
        }`}
        style={getFooterStyle(isSmallScreen, activeStep)}
      >
        <DealerInfo
          bookingDetails={bookingDetails}
          isSmallScreen={isSmallScreen}
          isIphoneScreen={isIphoneScreen}
          isAndroidScreen={isAndroidScreen}
        />
        <span
          className={getSpanClass(isDesktopScreen, istabletScreen)}
          style={{ marginTop: getMarginTop(activeStep, isDesktopScreen) }}
        >
          <PriceDisplay
            totalPrice={totalPrice}
            activeStep={activeStep}
            isDesktopScreen={isDesktopScreen}
            istabletScreen={istabletScreen}
            isSmallScreen={isSmallScreen}
          />
          <NavigationButtons
            activeStep={activeStep}
            isSmallScreen={isSmallScreen}
            prevActiveStep={prevActiveStep}
            handleNextClick={handleNextClick}
            totalPrice={totalPrice}
          />
        </span>
      </div>
    </div>
  );
}
export { BookingFooter };
